import { Routes } from '@angular/router';

// Guards
import { MsalGuard } from '@azure/msal-angular';
import {
  adminGuard,
  authGuard,
  initRolesGuard,
} from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [initRolesGuard, MsalGuard, authGuard],
    children: [
      // Routes for Truth.Read and Truth.Write
      {
        title: 'Home',
        loadComponent: () => import('./features/home/home.component'),
        path: '',
      },
      {
        title: 'Search',
        loadComponent: () => import('./features/search/search.component'),
        path: 'search',
      },

      // routes that need Truth.Write role

      // Authority Rules
      {
        title: 'Create Authority',
        loadComponent: () =>
          import(
            './features/authority-rule/authority-form/authority-form.component'
          ),
        path: 'authority-rules/create',
        canActivate: [adminGuard], // just for admins
      },
      {
        title: 'Edit Authority',
        loadComponent: () =>
          import(
            './features/authority-rule/authority-form/authority-form.component'
          ),
        path: 'authority-rules/edit/:id',
      },
      {
        title: 'History Authority',
        loadComponent: () =>
          import(
            './features/authority-rule/authority-form/authority-form.component'
          ),
        path: 'authority-rules/snapshot/:snapshotId',
      },

      // Control Report
      {
        title: 'Create Control Report',
        loadComponent: () =>
          import(
            './features/control-report/control-report-form/control-report-form.component'
          ),
        path: 'control-report/create',
        canActivate: [adminGuard],
      },
      {
        title: 'Edit Control Report',
        loadComponent: () =>
          import(
            './features/control-report/control-report-form/control-report-form.component'
          ),
        path: 'control-report/edit/:id',
      },
      {
        title: 'History Control Report',
        loadComponent: () =>
          import(
            './features/control-report/control-report-form/control-report-form.component'
          ),
        path: 'control-report/snapshot/:snapshotId',
      },

      // Borrower Communications Letter
      {
        title: 'Create Borrower Communications Letter',
        loadComponent: () =>
          import(
            './features/borrower-facing-communications-letter/borrower-facing-communications-letter-form/borrower-facing-communications-letter-form.component'
          ),
        path: 'borrower-facing-communications-letter/create',
        canActivate: [adminGuard],
      },
      {
        title: 'Edit Borrower Communications Letter',
        loadComponent: () =>
          import(
            './features/borrower-facing-communications-letter/borrower-facing-communications-letter-form/borrower-facing-communications-letter-form.component'
          ),
        path: 'borrower-facing-communications-letter/edit/:id',
      },
      {
        title: 'History Borrower Communications Letter',
        loadComponent: () =>
          import(
            './features/borrower-facing-communications-letter/borrower-facing-communications-letter-form/borrower-facing-communications-letter-form.component'
          ),
        path: 'borrower-facing-communications-letter/snapshot/:snapshotId',
      },

      // Business Standard
      {
        title: 'Create Business Standard',
        loadComponent: () =>
          import(
            './features/business-standard/business-standard-form/business-standard-form.component'
          ),
        path: 'business-standard/create',
        canActivate: [adminGuard],
      },
      {
        title: 'Edit Business Standard',
        loadComponent: () =>
          import(
            './features/business-standard/business-standard-form/business-standard-form.component'
          ),
        path: 'business-standard/edit/:id',
      },
      {
        title: 'History Business Standard',
        loadComponent: () =>
          import(
            './features/business-standard/business-standard-form/business-standard-form.component'
          ),
        path: 'business-standard/snapshot/:snapshotId',
      },

      // Subprocess
      {
        title: 'Create Subprocess',
        loadComponent: () =>
          import(
            './features/subprocess/subprocess-form/subprocess-form.component'
          ),
        path: 'subprocess/create',
        canActivate: [adminGuard],
      },
      {
        title: 'Edit Subprocess',
        loadComponent: () =>
          import(
            './features/subprocess/subprocess-form/subprocess-form.component'
          ),
        path: 'subprocess/edit/:id',
      },
      {
        title: 'History Subprocess',
        loadComponent: () =>
          import(
            './features/subprocess/subprocess-form/subprocess-form.component'
          ),
        path: 'subprocess/snapshot/:snapshotId',
      },

      // Documentation Procedure
      {
        title: 'Create Documentation Procedure',
        loadComponent: () =>
          import(
            './features/documentation-procedure/documentation-procedure-form/documentation-procedure-form.component'
          ),
        path: 'documentation/procedure/create',
        canActivate: [adminGuard],
      },
      {
        title: 'Edit Documentation Procedure',
        loadComponent: () =>
          import(
            './features/documentation-procedure/documentation-procedure-form/documentation-procedure-form.component'
          ),
        path: 'documentation/procedure/edit/:id',
      },
      {
        title: 'History Documentation Procedure',
        loadComponent: () =>
          import(
            './features/documentation-procedure/documentation-procedure-form/documentation-procedure-form.component'
          ),
        path: 'documentation/procedure/snapshot/:snapshotId',
      },
    ],
  },
  {
    title: 'auth',
    loadComponent: () => import('./features/auth/auth.component'),
    path: 'login',
  },
  {
    title: 'unauthorized',
    loadComponent: () =>
      import('./features/unauthorized/unauthorized.component'),
    path: 'unauthorized',
  },
];
